export const getSeo = (state) => state.seo;
